export const CardIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="80"
      viewBox="0 0 120 80"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_65_32)">
        <path
          d="M100 10H20C14.4772 10 10 14.4772 10 20V60C10 65.5228 14.4772 70 20 70H100C105.523 70 110 65.5228 110 60V20C110 14.4772 105.523 10 100 10Z"
          fill="#FFAB53"
        />
        <g filter="url(#filter0_d_65_32)">
          <path
            d="M42 38H22C20.8954 38 20 38.8954 20 40C20 41.1046 20.8954 42 22 42H42C43.1046 42 44 41.1046 44 40C44 38.8954 43.1046 38 42 38Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter1_d_65_32)">
          <path
            d="M70 38H50C48.8954 38 48 38.8954 48 40C48 41.1046 48.8954 42 50 42H70C71.1046 42 72 41.1046 72 40C72 38.8954 71.1046 38 70 38Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter2_d_65_32)">
          <path
            d="M98 38H78C76.8954 38 76 38.8954 76 40C76 41.1046 76.8954 42 78 42H98C99.1046 42 100 41.1046 100 40C100 38.8954 99.1046 38 98 38Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter3_d_65_32)">
          <path
            d="M28 20H22C20.8954 20 20 20.8954 20 22V28C20 29.1046 20.8954 30 22 30H28C29.1046 30 30 29.1046 30 28V22C30 20.8954 29.1046 20 28 20Z"
            fill="#E0E0E0"
          />
        </g>
        <g filter="url(#filter4_d_65_32)">
          <path
            d="M97 62C99.7614 62 102 59.7614 102 57C102 54.2386 99.7614 52 97 52C94.2386 52 92 54.2386 92 57C92 59.7614 94.2386 62 97 62Z"
            fill="#FF5722"
          />
        </g>
        <g filter="url(#filter5_d_65_32)">
          <path
            d="M89 62C91.7614 62 94 59.7614 94 57C94 54.2386 91.7614 52 89 52C86.2386 52 84 54.2386 84 57C84 59.7614 86.2386 62 89 62Z"
            fill="#FFEB3B"
          />
        </g>
      </g>
    </svg>
  );
};
